<template>
  <div class="app">
    <h1>股票资金流向 & 涨跌幅</h1>
    <div class="container">
      <div class="sidebar">
        <h3>股票列表</h3>
        <ul>
          <li v-for="name in stocks" :key="name" @click="loadStock(name)">
            {{ name }}
          </li>
        </ul>
      </div>
      <!-- 图表容器 -->
      <div class="chart" ref="chartRef"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";

const stocks = ref([]);
const chartRef = ref(null);
let chartInstance = null;

async function fetchStocks() {
  const res = await fetch("/api/stocks");
  stocks.value = await res.json();
}

async function loadStock(name) {
  const res = await fetch(`/api/stocks/${name}`);
  const data = await res.json();

  const dates = data.map(d => d.date);
  const flow = data.map(d => d.money);
  const increase = data.map(d => d.increase);

  chartInstance.setOption({
    title: {
      text: `股票：${name}`,   // 👈 在这里加股票名称
      left: "center"          // 居中显示
    },
    tooltip: { trigger: "axis" },
    legend: { data: ["资金流向", "涨跌幅"] },
    xAxis: { type: "category", data: dates },
    yAxis: [
      { type: "value", name: "资金流向" },
      { type: "value", name: "涨跌幅", position: "right" }
    ],
    series: [
      { name: "资金流向", type: "line", data: flow },
      { name: "涨跌幅", type: "line", yAxisIndex: 1, data: increase }
    ]
  });
}

onMounted(() => {
  fetchStocks();
  chartInstance = echarts.init(chartRef.value);
});
</script>

<style>
.app {
  font-family: Arial, sans-serif;
  padding: 20px;
}
.container {
  display: flex;
  align-items: flex-start;
}
.sidebar {
  width: 200px;
  border-right: 1px solid #ccc;
  margin-right: 20px;
  height: 80vh; /* 给个高度让列表可滚动 */
  overflow-y: auto;
}
.sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar li {
  padding: 8px;
  cursor: pointer;
}
.sidebar li:hover {
  background: #f0f0f0;
}

/* 让图表在滚动时保持固定可见 */
.chart {
  width: 800px;
  height: 500px;
  position: sticky;
  top: 20px; /* 滚动到距离顶部20px时固定 */
  background: #fff;
  border: 1px solid #ccc;
}
</style>
